'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';

export default function PreviewBanner() {
  const router = useRouter();

  const handleRefresh = () => {
    router.refresh();
  };

  return (
    <div className='fixed bottom-4 right-4 z-[9999] flex flex-col gap-2 rounded-lg bg-white p-3 shadow-xl border border-gray-200'>
      <div className='text-xs font-bold text-gray-800 text-center uppercase tracking-wider mb-1'>
        Draft Mode ON
      </div>
      <div className='flex gap-2'>
        <button
          onClick={handleRefresh}
          className='rounded bg-blue-50 px-3 py-1.5 text-blue-600 text-xs font-semibold hover:bg-blue-100 transition-colors border border-blue-200'
        >
          Refresh Data
        </button>
        <Link
          href='/preview/end'
          className='rounded bg-red-50 px-3 py-1.5 text-red-600 text-xs font-semibold hover:bg-red-100 transition-colors border border-red-200 text-center'
        >
          Exit Preview
        </Link>
      </div>
    </div>
  );
}
